import Module from './Module';
import ModulePopUp from './ModulePopup';
import manageFocus from '../services/manage-focus';

export default class ModulePopupGallery extends Module {
	constructor(el) {
		super(el);

		// -- Properties
		//--------------------------------------------------------------
		$.extend(this.dom, {
			links: el.find('.gallery'),
		});

		// Clear click events from all links
		$(this.dom.links).off('click');
	}

	// -- Methods
	//--------------------------------------------------------------
	init() {
		const variant =
			this.dom.el.data('variant') === 'creators' ? 'creators' : 'gallery';

		this.dom.links.featherlightGallery({
			variant,
			galleryFadeIn: 300,
			previousIcon: '&nbsp;<span class="sr-only">Previous</span>',
			nextIcon: '&nbsp;<span class="sr-only">Next</span>',
			openSpeed: 300,
			iframeMaxWidth: 1170,
			iframeMaxHeight: 658,

			// Analytics/ Tracking - virtual page views
			afterContent: (event) => {
				manageFocus();

				this.previousNext();

				const a = '?autoplay=1;fs=0';
				const f = document.querySelectorAll('.featherlight-iframe iframe');

				[].forEach.call(f, (el) => {
					el.src += a;
				});

				const el = $.featherlight.current().$currentTarget;
				const ref = {
					parent: el.data('item-parent'),
					dataAttr: el.data('item-data-attr'),
					dataAlt: el.data('item-alt'),
				};

				const name = $.featherlight
					.current()
					.$currentTarget.closest(ref.parent)
					.data(ref.dataAttr);

				const instance = $.featherlight.current().$instance;
				const image = instance.find('.featherlight-content img');
				image.attr('alt', ref.dataAlt);

				if (el[0].hasAttribute('data-item-template')) {
					const info = el[0].dataset.itemTemplate;
					const featherlightContent = instance.find('.featherlight-content');

					if (!$('.featherlight-wrapper').length) {
						featherlightContent.wrapInner(
							'<div class="featherlight-wrapper"></div>'
						);
					}

					featherlightContent.append(info);
				}

				instance
					.find('.featherlight-next, .featherlight-previous')
					.one('click', () => {
						$('.featherlight-wrapper img').unwrap();
						$('.featherlight-template').remove();
					});
			},
		});
	}

	previousNext() {
		const nextButton = $('.featherlight-next');
		const prevButton = $('.featherlight-previous');

		$('.featherlight-next, .featherlight-previous').attr('tabindex', '0');

		nextButton.keyup((e) => {
			if (e.keyCode == '13') {
				nextButton.click();
			}
		});
	}

	get mobilePortrait() {
		let status = false;
		if (this.dom.w.width() < 480) {
			status = true;
		}
		return status;
	}
}
